import { render, staticRenderFns } from "./vipTransfer.vue?vue&type=template&id=a495a428&scoped=true"
import script from "./vipTransfer.vue?vue&type=script&lang=js"
export * from "./vipTransfer.vue?vue&type=script&lang=js"
import style0 from "./vipTransfer.vue?vue&type=style&index=0&id=a495a428&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a495a428",
  null
  
)

export default component.exports